import { Link } from "react-router-dom";

export function NachEvent() {

  return (
    <>

      <div style={{ width: "100%" }}>

        <div className="max-w rounded overflow-hidden shadow-lg text-2xl mt-20">
          <div className="card-body" style={{ "width": "100%", padding: "30px" }}>
            <h4 style={{ "textAlign": "center" }}>Volkslauf Neermoor 2026</h4>
            <h4 style={{ "textAlign": "center" }}>am Sonntag dem 28.06.2026</h4>
            <h4 style={{ "textAlign": "center" }}>in der Wilhelmsstr. 2 in 26802 Moormerland</h4>
          </div>
        </div>

        <div className="max-w rounded overflow-hidden shadow-lg mt-12 p-4">

          Diesjähriges Motto:
          <div className="flex justify-center">
            <img alt="nöös an nöös" src="/img/nöös_an_nöös.jpeg" style={{ height: "300px", width: "300px" }} />
          </div>

          <div>
            <p className="text-2xl">Liebe Läufer,</p>
            <p className="pt-4">
              vielen Dank für eure Teilnahme am Volkslauf Neermoor 2026! Wir hoffen, ihr hattet eine tolle Zeit und konntet eure persönlichen Ziele erreichen.
            </p>

          </div>
        </div>

        <div className="max-w rounded overflow-hidden shadow-lg mt-12 p-4">
          <p className="text-2xl">Urkunden</p>
          <p className="pt-8">
            Die Urkunden können auf der <Link className="hover:text-gray-200" to="/rangliste">Ranglistenseite</Link> heruntergeladen werden. Die Urkunden sind als PDF-Datei verfügbar und können ausgedruckt werden.
            Es gibt für die Erwachsenen läufe zwei Versionen der Urkunde: eine mit Platzierung und eine ohne Platzierung.
            Für die Kinderläufe gibt es zur Zeit eine Version der Urkunde.
          </p>
        </div>

      </div>


    </>
  );
}

export default NachEvent;